import React from "react";
import lazyPage from "../../../common/helpers/lazyPage";
import PageLoader from "../../components/PageLoader";

export default lazyPage(
    "src/front/pages/moderate-exercise/moderate-exercise.tsx",
    () => import("./moderate-exercise"),
    <PageLoader />,
);
